"use client";

import { useEffect, useState } from "react";
import Link from "next/link";
import { Scale } from "lucide-react";
import { useTranslations } from "next-intl";
import { compareQueryFromIds, readCompareCarIds, writeCompareCarIds, MAX_COMPARE_CARS } from "@/lib/compare-cars";

export default function CompareStickyBar() {
  const [count, setCount] = useState(0);
  const [ids, setIds] = useState<string[]>([]);
  const t = useTranslations("ComparePage");

  useEffect(() => {
    const sync = () => {
      const list = readCompareCarIds();
      setCount(list.length);
      setIds(list);
    };
    const timer = window.setTimeout(sync, 0);
    window.addEventListener("beepbeep-compare-change", sync);
    window.addEventListener("storage", sync);
    return () => {
      window.clearTimeout(timer);
      window.removeEventListener("beepbeep-compare-change", sync);
      window.removeEventListener("storage", sync);
    };
  }, []);

  if (count < 1) return null;

  const href = `/cars/compare?ids=${compareQueryFromIds(ids)}`;

  return (
    <div
      className="fixed bottom-0 left-0 right-0 z-40 border-t border-gray-200 bg-white/95 px-4 py-3 shadow-[0_-4px_24px_rgba(0,0,0,0.08)] backdrop-blur dark:border-gray-800 dark:bg-gray-950/95"
      role="region"
      aria-label={t("stickyBarAria")}
    >
      <div className="mx-auto flex max-w-7xl flex-wrap items-center justify-between gap-3">
        <p className="flex items-center gap-2 text-sm text-gray-700 dark:text-gray-200">
          <Scale size={16} className="text-[#E63946]" aria-hidden />
          <span>{t("stickyCompareCount", { count, max: MAX_COMPARE_CARS })}</span>
        </p>
        <div className="flex flex-wrap gap-2">
          <button
            type="button"
            className="text-xs text-gray-500 underline underline-offset-2 hover:text-gray-700 dark:text-gray-400 dark:hover:text-gray-200"
            onClick={() => writeCompareCarIds([])}
          >
            {t("stickyClear")}
          </button>
          <Link
            href={href}
            className="inline-flex items-center gap-1 rounded-xl bg-[#E63946] px-4 py-2 text-sm font-semibold text-white hover:bg-[#c1121f]"
          >
            {t("stickyOpen")}
          </Link>
        </div>
      </div>
    </div>
  );
}
